import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

import { useAuthStore } from '@/store/auth.store'
import { API_BASE } from '@/lib/constants'

declare global {
  interface Window {
    Pusher: typeof Pusher
  }
}

let echo: Echo<'reverb'> | null = null

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '0.0.0.0', '::1'])

/** Canlı derlemede VITE_REVERB_HOST localhost kalırsa tarayıcı kendi makinesine bağlanır. */
function reverbEndpoint() {
  const configuredHost = String(import.meta.env.VITE_REVERB_HOST || 'localhost')
  const configuredPort = Number(import.meta.env.VITE_REVERB_PORT || 8080)
  const configuredTls = (import.meta.env.VITE_REVERB_SCHEME || 'http') === 'https'
  const pageHost = window.location.hostname

  if (!LOCAL_HOSTS.has(pageHost) && LOCAL_HOSTS.has(configuredHost)) {
    const tls = window.location.protocol === 'https:'
    return {
      wsHost: pageHost,
      wsPort: tls ? 443 : 80,
      wssPort: tls ? 443 : 80,
      forceTLS: tls,
    }
  }

  return {
    wsHost: configuredHost,
    wsPort: configuredPort,
    wssPort: configuredPort,
    forceTLS: configuredTls,
  }
}

export function getEcho(): Echo<'reverb'> {
  if (echo) return echo

  window.Pusher = Pusher
  const endpoint = reverbEndpoint()

  echo = new Echo({
    broadcaster: 'reverb',
    key: import.meta.env.VITE_REVERB_APP_KEY ?? 'saas-key',
    wsHost: endpoint.wsHost,
    wsPort: endpoint.wsPort,
    wssPort: endpoint.wssPort,
    forceTLS: endpoint.forceTLS,
    enabledTransports: ['ws', 'wss'],
    disableStats: true,
    authorizer: (channel: { name: string }) => ({
      authorize: (socketId: string, callback: (error: boolean, data: unknown) => void) => {
        const token = useAuthStore.getState().token
        fetch(`${API_BASE}/broadcasting/auth`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          body: JSON.stringify({ socket_id: socketId, channel_name: channel.name }),
        })
          .then((res) => res.json())
          .then((data) => callback(false, data))
          .catch(() => callback(true, null))
      },
    }),
  })

  return echo
}

export function disconnectEcho() {
  if (echo) {
    echo.disconnect()
    echo = null
  }
}
